const brickCreationScript = `
  const unmountCardPaymentBrick = async () => {
    if (window.cardPaymentBrickController) {
      try {
        await window.cardPaymentBrickController.unmount();
        window.cardPaymentBrickController = null;
      } catch (error) {
        console.error('Error during unmount:', error);
      }
    }
  };

  unmountCardPaymentBrick();

  const mp = new MercadoPago(window.cardPaymentBricksProps.publicKey, {
    locale: window.cardPaymentBricksProps.language,
    trackingDisabled: true
  });
  const bricksBuilder = mp.bricks({theme: window.cardPaymentBricksProps.theme});
  const renderCardPaymentBrick = async (bricksBuilder) => {

    const settings = {
      initialization: {
        amount: 10000, //valor do processamento a ser realizado. Deve ser um número inteiro
        payer: window.cardPaymentBricksProps.payer,
      },
      callbacks: {
        onReady: () => {
          // callback chamado quando o Brick estiver pronto
        },
        onSubmit: (cardFormData) => {
        },
        onError: (error) => {
          // callback chamado para todos os casos de erro do Brick
        },
      },
      customization: {
        visual: {
          hidePaymentButton: window.cardPaymentBricksProps.hidePaymentButton,
          hideFormTitle: window.cardPaymentBricksProps.hideFormTitle,
          texts: window.cardPaymentBricksProps.texts,
          style: {
            customVariables: window.cardPaymentBricksProps.customVariables,
          },
          paymentMethods: {
            types:{
              excluded: window.cardPaymentBricksProps.paymentMethod,
            },
            maxInstallments: window.cardPaymentBricksProps.maxInstallments,
          },
        },
      },
    };
    window.cardPaymentBrickController = await bricksBuilder.create('cardPayment', 'cardPaymentBrick_container', settings);
  };
  renderCardPaymentBrick(bricksBuilder);
  `;

const paymentMethods = ['credit_card', 'debit_card'];

module.exports = { brickCreationScript, paymentMethods };
